import { render, staticRenderFns } from "./eShopInfo.vue?vue&type=template&id=0e2bfabe&scoped=true"
import script from "./eShopInfo.vue?vue&type=script&lang=js"
export * from "./eShopInfo.vue?vue&type=script&lang=js"
import style0 from "./eShopInfo.vue?vue&type=style&index=0&id=0e2bfabe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2bfabe",
  null
  
)

export default component.exports